export const Fragment = 'fragment'; // Метка для фрагмента
export function h(tag, props, ...children) {
    if (tag === Fragment) {
        return children.flat().map(child => child instanceof Node ? child : document.createTextNode(child.toString()));
    }
    const el = document.createElement(tag);
    if (props) {
        Object.entries(props).forEach(([key, value]) => {
            if (key.startsWith('on')) {
                el.addEventListener(key.toLowerCase().substring(2), value);
            }
            else if (key === 'className' || key === 'class') {
                el.setAttribute('class', value);
            }
            else {
                el.setAttribute(key, value);
            }
        });
    }
    children.flat().forEach(child => {
        if (child !== null && child !== undefined && child !== false) {
            el.append(child instanceof Node ? child : document.createTextNode(child));
        }
    });
    return el;
}
